import React, { useState } from "react";
import "./HomePage.css";
import cityBg from "../photos/city.jpeg";
import logo from "../photos/metalVentureslogo.png";
import nonFerrousImg from "../photos/non-ferrous_2.jpg";
import preciousImg from "../photos/PreciousMetals.jpg";
import ferrousImg from "../photos/FerrousMaterial.PNG";
import extrusions from "../photos/extrusions.png";
import istock from "../photos/istock.jpg";
import extrusionsHome from "../photos/extrusionshome.jpg";
import steveSteel from "../photos/stevesteel.jpg";
import ContactForms from "../Components/ContactComponent/ContactForms";

function HomePage() {
  const serviceImages = [
    {
      img: steveSteel,
      title: "Ferrous Scrap",
    },
    {
      img: nonFerrousImg,
      title: "Non-Ferrous Metals",
    },
    {
      img: preciousImg,
      title: "Precious Metals",
    },
  ];

  const [activeImage, setActiveImage] = useState(null);

  const openModal = (index) => {
    setActiveImage(index);
  };

  const closeModal = () => {
    setActiveImage(null);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setActiveImage((prev) => (prev + 1) % serviceImages.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setActiveImage((prev) =>
      prev === 0 ? serviceImages.length - 1 : prev - 1
    );
  };

  return (
    <main className="home-page">
      {/* HERO SECTION */}
<section
  className="hero"
  style={{
  backgroundImage: `
    linear-gradient(to right, rgba(0,0,0,0.85), rgba(0,0,0,0.3)),
    url(${extrusionsHome})
  `,
}}
>
  <div className="hero-content">
    <p className="eyebrow">Trusted Global Partner In</p>

    <h1>
      Global Metal
      <br />
      Markets
      <span className="headline-line">& Strategic Partnerships</span>
    </h1>

    <div className="slogan-wrap no-icon">
  <div className="slogan-lines">
    <span className="gold-line"></span>
    <h2>Turning Scrap Into Value.</h2>
    <span className="gold-line"></span>
  </div>
</div>
    <p className="hero-description">
      We connect global markets with sustainable metal solutions through
      integrity, innovation, and excellence.
    </p>

    <div className="hero-buttons">
      <a href="#about" className="btn gold">Learn More</a>
      <a href="#contact" className="btn outline">Contact Us</a>
    </div>
  </div>
</section>

     <section id="about" className="about-section">
  <div className="container about-content">

    {/* LEFT SIDE */}
    <div className="about-text">
      <span className="about-eyebrow">ABOUT US</span>

      <h2>ABOUT US</h2>

      <div className="about-brush"></div>

      <p className="about-intro">
        Based in the United States, Global Metal Ventures stands as a
        trailblazer in the metal trading industry, where innovation
        seamlessly integrates with robust partnerships.
      </p>

      <p>
        Since our establishment in 2018, our mission has been to redefine
        industry standards and make a lasting impact. Our reach extends
        beyond national boundaries, covering both domestic and
        international markets, including significant engagement in Mexico.
      </p>

      <p>
        As metal traders, our global and domestic presence is fortified by
        strategic partnerships that are integral to our success,
        contributing significantly to our impact both locally and abroad.
      </p>

      <a href="#contact" className="btn gold">Learn More</a>
    </div>

    {/* RIGHT SIDE CARD */}
    <div className="about-card">
  <div className="about-card-content">

    <div className="about-card-item">
      <h4>2018</h4>
      <span>MEXICO OPERATIONS</span>
      <p>
        Established strong trading relationships and strategic partnerships
        throughout Mexico.
      </p>
    </div>

    <div className="about-divider"></div>

    <div className="about-card-item">
      <h4>2025 • ASIA MARKETS</h4>
      <p>
        Expanding operations across Asian markets through strategic sourcing,
        metal trading, and international partnerships.
      </p>
    </div>

    <div className="about-divider"></div>

    <div className="about-card-item">
      <h4>STRATEGIC PARTNERSHIPS</h4>
      <p>
        Collaborating with trusted global partners to deliver long-term value
        and sustainable metal solutions.
      </p>
    </div>

  </div>
</div>
</div>
</section>
      {/* SERVICES SECTION */}
      <section id="services" className="services-section">
        <div className="container">
          <div className="section-header premium-header">
            <span>What We Specialize In</span>
            <div className="gold-divider"></div>

            <h2>
              Ferrous & Non-Ferrous Metals
              <br />
              & Precious Materials
            </h2>

            <p className="section-subtext">
              We specialize in a broad range of non-ferrous materials, spanning
              across global markets to include high-value precious metals.
            </p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <img
                src={steveSteel}
                alt="Ferrous material"
                className="service-click-img"
                onClick={() => openModal(0)}
              />
              <div className="service-content">
                <h3>Ferrous Scrap</h3>
                <span className="card-line"></span>
                <p>
                  High-grade ferrous scrap sourced responsibly and processed to
                  meet global quality standards.
                </p>
              </div>
            </div>

            <div className="service-card">
              <img
                src={nonFerrousImg}
                alt="Non-ferrous scrap"
                className="service-click-img"
                onClick={() => openModal(1)}
              />
              <div className="service-content">
                <h3>Non-Ferrous Metals</h3>
                <span className="card-line"></span>
                <p>
                  Copper, aluminum, brass and more, supplied clean, sorted, and
                  ready for international markets.
                </p>
              </div>
            </div>

            <div className="service-card">
              <img
                src={preciousImg}
                alt="Precious metals"
                className="service-click-img"
                onClick={() => openModal(2)}
              />
              <div className="service-content">
                <h3>Precious Metals</h3>
                <span className="card-line"></span>
                <p>
                  Connecting buyers and suppliers through reliable domestic and
                  international trading solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* POP OUT IMAGE MODAL */}
      {activeImage !== null && (
        <div className="photo-modal-overlay" onClick={closeModal}>
          <div className="photo-modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="photo-modal-close" onClick={closeModal}>
              ×
            </button>

            <img
              src={serviceImages[activeImage].img}
              alt={serviceImages[activeImage].title}
              className="photo-modal-img"
            />

            <h3>{serviceImages[activeImage].title}</h3>
            <span className="modal-gold-line"></span>
          </div>
        </div>
      )}

      {/* CONTACT SECTION */}
      <section id="contact" className="contact-section">
        <div className="container contact-content">
          <div className="contact-info">
            <span>Get In Touch</span>
            <h2>Let’s Build a Stronger Metal Supply Chain</h2>
            <p>
              Contact Global Metal Ventures for sourcing, recycling, trading,
              and partnership opportunities across domestic and international
              markets.
            </p>

            <div className="contact-details">
              <p><strong>Markets:</strong> United States, Mexico & Asia</p>
            </div>
          </div>

          {/* ✅ ONLY CHANGE MADE */}
          <ContactForms />

        </div>
      </section>

      {/* LOCATION SECTION */}
      <section id="location" className="location-section">
        <div className="container">
          <div className="section-header">
            <span>Find Us</span>
            <h2>Located in the United States</h2>
          </div>

          <div className="map-container">
            <iframe
              title="Location Map"
              src="https://www.google.com/maps?q=512+E+Pine+Street+Compton+CA+90222&output=embed"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>

<footer className="footer">
  <p>© {new Date().getFullYear()} Global Metal Ventures. All rights reserved.</p>
</footer>

    </main>
  );
}

export default HomePage;